var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2991 7.67123C20.1707 7.26626 19.8205 6.97954 19.4078 6.94124L13.7787 6.41709L11.5541 1.07521C11.3898 0.682743 11.0161 0.429443 10.6001 0.429443C10.1841 0.429443 9.81027 0.682743 9.64707 1.07521L7.42242 6.41709L1.79245 6.94124C1.37975 6.9803 1.03028 7.26702 0.90114 7.67123C0.772746 8.07621 0.89132 8.5204 1.20345 8.80116L5.45859 12.628L4.20396 18.2955C4.11217 18.7122 4.26987 19.1431 4.60699 19.3931C4.7882 19.5281 5.0011 19.5956 5.21474 19.5956C5.39833 19.5956 5.58207 19.5455 5.74617 19.4448L10.6001 16.4681L15.4532 19.4448C15.8092 19.663 16.2569 19.643 16.5933 19.3931C16.9304 19.1431 17.0881 18.7122 16.9963 18.2955L15.7417 12.628L19.9968 8.80116C20.3088 8.5204 20.4275 8.07712 20.2991 7.67123Z",
    fill: "#C1C1C1",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star-empty.f9eb05a51f872389695da0f01d1f867e.svg";
export { ForwardRef as ReactComponent };